import React from 'react'
import { useLazyLoadQuery, graphql } from 'react-relay'
import { useParams } from 'react-router-dom'

import { YStack } from 'tamagui'

import { UserMetadata } from '@newComponents/User/UserMetadata'

import { UserGuildMembershipsOrganizersSection } from './UserGuildMembershipsOrganizersSection'
import { UserGuildMembershipsEditorsSection } from './UserGuildMembershipsEditorsSection'
import { UserGuildMembershipsMembersSection } from './UserGuildMembershipsMembersSection'

import { UserGuildMembershipsScreenQuery } from './__generated__/UserGuildMembershipsScreenQuery.graphql'

export const UserGuildMembershipsScreen = () => {
  const params = useParams()

  const data = useLazyLoadQuery<UserGuildMembershipsScreenQuery>(
    graphql`
      query UserGuildMembershipsScreenQuery($id: String!) {
        nodeBySlugId(id: $id) {
          __typename

          ... on User {
            firstName
            lastName

            ...UserMetadata_user

            ...UserGuildMembershipsOrganizersSection_user
            ...UserGuildMembershipsMembersSection_user
            ...UserGuildMembershipsEditorsSection_user
          }
        }
      }
    `,
    { id: params.actorId! }
  )

  if (data.nodeBySlugId?.__typename !== 'User') {
    return null
  }

  return (
    <>
      <UserMetadata
        user={data.nodeBySlugId}
        title={`${data.nodeBySlugId.firstName} ${data.nodeBySlugId.lastName}'s Guilds`}
      />

      <YStack gap='$5'>
        <UserGuildMembershipsOrganizersSection user={data.nodeBySlugId} />

        <UserGuildMembershipsEditorsSection user={data.nodeBySlugId} />

        <UserGuildMembershipsMembersSection user={data.nodeBySlugId} />
      </YStack>
    </>
  )
}

export default UserGuildMembershipsScreen
